import React from 'react';
import { Link } from 'react-router-dom';

const VisionPage = () => {
  const headerStyle = {
    background: 'linear-gradient(135deg, var(--navy-blue) 0%, var(--baby-blue) 100%)',
    color: 'var(--white)',
    padding: '80px 0',
    textAlign: 'center'
  };

  const sectionStyle = {
    padding: '60px 0'
  };

  const cardStyle = {
    background: 'var(--white)',
    borderRadius: '12px',
    padding: '32px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    marginBottom: '32px'
  };

  const iconStyle = {
    fontSize: '48px',
    marginBottom: '20px',
    display: 'block',
    textAlign: 'center'
  };

  const titleStyle = {
    fontSize: '24px',
    fontWeight: '600',
    color: 'var(--navy-blue)',
    marginBottom: '16px',
    fontFamily: 'Comfortaa, cursive',
    textAlign: 'center'
  };

  const valueCardStyle = {
    ...cardStyle,
    textAlign: 'center',
    transition: 'transform 0.3s ease'
  };

  return (
    <div>
      {/* Header */}
      <section style={headerStyle}>
        <div className="container">
          <h1 style={{ fontSize: '48px', marginBottom: '20px', fontFamily: 'Comfortaa, cursive' }}>
            Vizyonumuz
          </h1>
          <p style={{ fontSize: '20px', opacity: 0.9, maxWidth: '600px', margin: '0 auto' }}>
            Türkiye'nin en güvenilir ve kapsamlı işletme rehberi olmak
          </p>
        </div>
      </section>

      <div className="container">
        {/* Mission Section */}
        <section style={sectionStyle}>
          <div style={cardStyle}>
            <h2 style={{ 
              fontSize: '32px', 
              textAlign: 'center', 
              marginBottom: '24px', 
              color: 'var(--navy-blue)',
              fontFamily: 'Comfortaa, cursive'
            }}>
              Misyonumuz
            </h2>
            <p style={{ 
              fontSize: '18px', 
              lineHeight: '1.8', 
              color: 'var(--gray-600)', 
              textAlign: 'center',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              Kolay Servis olarak, insanların ihtiyaç duydukları hizmetleri kolayca bulabilecekleri, 
              güvenilir ve kapsamlı bir platform sunmayı hedefliyoruz. Türkiye'nin her köşesindeki 
              işletmeleri bir araya getirerek, hem tüketicilere hem de işletmelere değer katmak 
              temel misyonumuzdur.
            </p>
          </div>
        </section>

        {/* Values Section */}
        <section style={sectionStyle}>
          <h2 style={{ 
            fontSize: '32px', 
            textAlign: 'center', 
            marginBottom: '48px', 
            color: 'var(--navy-blue)',
            fontFamily: 'Comfortaa, cursive'
          }}>
            Değerlerimiz
          </h2>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '32px' 
          }}>
            <div 
              style={valueCardStyle}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <span style={iconStyle}>🎯</span>
              <h3 style={titleStyle}>Güvenilirlik</h3>
              <p style={{ color: 'var(--gray-600)', lineHeight: '1.6' }}>
                Platformumuzdaki tüm işletmeleri titizlikle inceleyerek, 
                kullanıcılarımıza güvenilir hizmet sağlayıcıları sunuyoruz.
              </p>
            </div>

            <div 
              style={valueCardStyle}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <span style={iconStyle}>🚀</span>
              <h3 style={titleStyle}>Yenilikçilik</h3>
              <p style={{ color: 'var(--gray-600)', lineHeight: '1.6' }}>
                Teknolojinin gücünü kullanarak, kullanıcı deneyimini sürekli 
                geliştiren yenilikçi çözümler üretiyoruz.
              </p>
            </div>

            <div 
              style={valueCardStyle}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <span style={iconStyle}>🤝</span>
              <h3 style={titleStyle}>İş Birliği</h3>
              <p style={{ color: 'var(--gray-600)', lineHeight: '1.6' }}>
                İşletmeler ve müşteriler arasında güçlü köprüler kurarak, 
                karşılıklı fayda sağlayan ilişkiler geliştiriyoruz.
              </p>
            </div>

            <div 
              style={valueCardStyle}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <span style={iconStyle}>🌟</span>
              <h3 style={titleStyle}>Kalite</h3>
              <p style={{ color: 'var(--gray-600)', lineHeight: '1.6' }}>
                Platformumuzda yer alan her işletmenin kaliteli hizmet sunmasını 
                sağlayarak, müşteri memnuniyetini önceleyiyoruz.
              </p>
            </div>

            <div 
              style={valueCardStyle}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <span style={iconStyle}>📱</span>
              <h3 style={titleStyle}>Erişilebilirlik</h3>
              <p style={{ color: 'var(--gray-600)', lineHeight: '1.6' }}>
                Her yaştan ve her kesimden kullanıcının kolayca erişebileceği, 
                kullanıcı dostu bir platform sunuyoruz.
              </p>
            </div>

            <div 
              style={valueCardStyle}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <span style={iconStyle}>🌍</span>
              <h3 style={titleStyle}>Kapsayıcılık</h3>
              <p style={{ color: 'var(--gray-600)', lineHeight: '1.6' }}>
                Türkiye'nin her bölgesindeki işletmelere eşit fırsat tanıyarak, 
                kapsayıcı bir ekosistem oluşturuyoruz.
              </p>
            </div>
          </div>
        </section>

        {/* Goals Section */}
        <section style={sectionStyle}>
          <div style={cardStyle}>
            <h2 style={{ 
              fontSize: '32px', 
              textAlign: 'center', 
              marginBottom: '32px', 
              color: 'var(--navy-blue)',
              fontFamily: 'Comfortaa, cursive'
            }}>
              Hedeflerimiz
            </h2>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
              gap: '24px',
              marginTop: '32px'
            }}>
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '36px', fontWeight: 'bold', color: 'var(--baby-blue)', marginBottom: '8px' }}>
                  81
                </div>
                <p style={{ color: 'var(--gray-600)' }}>İl Kapsamı</p>
              </div>
              
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '36px', fontWeight: 'bold', color: 'var(--baby-blue)', marginBottom: '8px' }}>
                  50+
                </div>
                <p style={{ color: 'var(--gray-600)' }}>Hizmet Kategorisi</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section style={{ ...sectionStyle, textAlign: 'center' }}>
          <div style={{
            background: 'linear-gradient(135deg, var(--navy-blue) 0%, var(--baby-blue) 100%)',
            color: 'var(--white)',
            borderRadius: '12px',
            padding: '60px 40px'
          }}>
            <h2 style={{ 
              fontSize: '32px', 
              marginBottom: '20px', 
              fontFamily: 'Comfortaa, cursive'
            }}>
              Bizimle Büyüyün
            </h2>
            <p style={{ fontSize: '18px', marginBottom: '32px', opacity: 0.9 }}>
              Vizyonumuzu gerçekleştirmek için sizin de desteğinize ihtiyacımız var
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/firma-ekle" className="btn btn-secondary" style={{ fontSize: '16px' }}>
                Firmanızı Ekleyin
              </Link>
              <Link to="/iletisim" className="btn" style={{ 
                backgroundColor: 'transparent', 
                border: '2px solid var(--white)',
                color: 'var(--white)',
                fontSize: '16px'
              }}>
                İletişime Geçin
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default VisionPage;